// @flow
import React, { type Node } from 'react';
import './PlainTemplate.scss';

type Props = {
  children: Node,
};

const PlainTemplate = ({ children }: Props) => (
  <div className="PlainTemplate">
    <div className="content-area">{children}</div>
  </div>
);

export default PlainTemplate;



// WEBPACK FOOTER //
// ./src/components/common/PlainTemplate/PlainTemplate.js